import { Markdown } from './Markdown';

interface Props {
  role: 'user' | 'assistant';
  content: string;
  agentName?: string;
  pending?: boolean;
}

export function ChatMessage({ role, content, agentName, pending }: Props) {
  const isUser = role === 'user';
  return (
    <div class={`flex gap-2 sm:gap-3 ${isUser ? 'justify-end' : ''}`}>
      {!isUser && (
        <div class="size-8 rounded-md border border-border bg-card flex items-center justify-center shrink-0">
          <i class="ph ph-robot text-base" />
        </div>
      )}
      <div class={`min-w-0 max-w-[85%] sm:max-w-3xl ${isUser ? 'order-1' : ''}`}>
        {!isUser && agentName && (
          <div class="text-xs text-muted-foreground mb-1">{agentName}</div>
        )}
        <div
          class={`px-3 sm:px-3.5 py-2 sm:py-2.5 rounded-md border break-words ${
            isUser
              ? 'bg-muted border-border'
              : 'bg-card border-border'
          } ${pending ? 'opacity-70' : ''}`}
        >
          {content ? <Markdown content={content} /> : <span class="text-muted-foreground text-sm">…</span>}
        </div>
      </div>
      {isUser && (
        <div class="size-8 rounded-md border border-border bg-card flex items-center justify-center shrink-0">
          <i class="ph ph-user text-base" />
        </div>
      )}
    </div>
  );
}
